import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
import VueApexCharts from 'vue-apexcharts'
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import PopUpCadastroPontoInteresse from '@/views/concept/frota/ponto-interesse/PopUpCadastroPontoInteresse';
import BtnAggridComponentRenderer from './ChecBoxAggridComponent.vue';
import 'vue-select/dist/vue-select.css';

export default {  
  props: {
    pVeiculoSelecionado: {
      type: Object,
      required: false
    }, 
  },
  components: {
    AgGridVue,
    flatPickr,
    VueApexCharts,   
    PopUpCadastroPontoInteresse ,
    BtnAggridComponentRenderer    
  },  
  created(){
    window.click_AbrirPopUpCriarPoI = this.click_AbrirPopUpCriarPoI;
    // Variaveis criadas para não serem reativas.
    this.listaCoresPercurso = ["#FD3434", "#3B34FD", "#000000", "#98998E", "#D1E607" ];
    //this.dadosPercursoSelecionado = { lista: [], listaAvisosPercursosSelecionado: [], resumo: { consumo: '',  distanciaPercorrida: '', duracaoPercurso: '', horimetroCalculado: '', periodoPercurso: '', tempoParado: '', tempoParadoLigado: '', velocidadeMaxima: '', velocidadeMedia: '' }, cor: null };
    
    this.arrMarkerTodosPercursos = [];
    this.arrPolylines = [];
    this.arrMarkerPercurso = [];
    this.arrMarkerAvisos = [];
    this.infowindow = null;
    this.markerInfowindow = null;
    this.botaoVerTodosDiv = null;
    this.botaoImprimirDiv = null;
    this.quadroCalculoDiv = null;
    this.btnLimparAreaDiv = null;
    this.botaoExibirOcultarPoI = null;
    this.botaoExibirOcultarAvisos = null;
    this.marcadorPlay = null;
    
    this.configDatePicker = {          
      altInput: true,
      altFormat: "d-m-Y",
      dateFormat: "U", 
      altInputClass: "vs-inputx vs-input--input normal hasValue small campoData",
      locale: PortugueseLocale
    };
    this.timePicker = {          
      altInput: true,
      altFormat: "H:i",
      dateFormat: "Hi",
      enableTime: true,          
      altInputClass: "vs-inputx vs-input--input normal hasValue ml-2 small campoHora",
      locale: PortugueseLocale,  
      noCalendar: true
    };
    this.passoAnimacao = 0;
    this.marcadoresExibidos = true;
    this.quebraPorZoom = [[],[],[],[],[]];  
  },
  data() {
    return {      
      dadosPercursoSelecionado: { lista: [], listaAvisosPercursosSelecionado: [], resumo: { consumoLporH: '', consumo: '',  distanciaPercorrida: '', duracaoPercurso: '', horimetroCalculado: '', periodoPercurso: '', tempoParado: '', tempoParadoLigado: '', velocidadeMaxima: '', velocidadeMedia: '' }, cor: null, chkExibirSohParadas: false, chkExibirMakerEmMovimento: true, exibirPercursoBkp: false },
      tabGeral: 0,
      chkAbrirNovaJanela: false,
      chkApagarAnterior: true,
      chkExibirOrdem: false,
      chkExibirSohParadas: false,   
      chkExibirSohParadasOuter: false,   
      chkExibirMakerEmMovimento: true,
      perfilVelocidade: null,
      tempoMinimoParada: 2,
      exibirPopUpParametroHora: false,
      dadosPopUpParametroHora: {
        filtroHoraInicio: "0000" ,
        filtroHoraFim: "2359",
        filtro2HoraInicio:"0900",
        filtro2HoraFim: "0959",
        filtro3HoraInicio: "1000",
        filtro3HoraFim: "1059" ,
        filtro4HoraInicio: "1100",
        filtro4HoraFim: "1159",
        filtro5HoraInicio: "1500",
        filtro5HoraFim: "1559",
        filtro6HoraInicio: "1600",
        filtro6HoraFim: "1659",
        exibirOutrasFaixasHorario: false,
        indiceFaixa: 1, 
        limpouAnteriores: false
      },
      consolidadoPercursoSelecionado: [],
      passoSelecionadoPercurso: null,      
      listaVeiculos: [],
      listaConsolidadoPercursos: [],      
      filtroVeiculoSelecionado: null,        
      filtroDataInicio: null,     
      filtroHoraInicio: "0000",    
      filtroDataFim: null,       
      filtroHoraFim: "2359",
      filtroVelocidade: null,
      filtroDistanciaDeslocamento: null,
      map: null,
      exibirMensagemNenhumDadoEncontrado: false,
      exibirGraficoVelocidadesLinha: false,
      graficoVelocidadesLinha: {               
        series: [{
              name: 'Receitas',
              data: [175, 125, 225, 175, 160, 189, 206, 134, 159, 216, 148, 123]
          }],
        chartOptions: {
          chart: {
            height: 250,
            type: 'line',
            animations: {
              enabled: false // Desativa animações para melhorar performance
            },
            zoom: { enabled: true, type: 'x', autoScaleYaxis: true },
            events: {
              dataPointSelection: (event, chartContext, config) => {                                         
                this.exibirMarcadorDaVelocidade(config.dataPointIndex);
              }
            }
          },
          markers:{
            size: 2
          },
          tooltip: {
            intersect: true,
            shared: false
          },
          dataLabels: { enabled: false },
          stroke: { curve: 'straight', width: 2 },
          title: { text: 'Velocidades', align: 'left' },
          grid: { row: { colors: ['#f3f3f3', 'transparent'],  opacity: 0.5 }, },
          xaxis: {
            labels: {  show: true,  rotate: -90, style: {fontSize: '8px', fontColor: 'black'} },
            type: 'datetime',
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          }
        }
      },
      graficoVelocidades: {
        series: [{            
            data: []
        }],
        chartOptions: {
          colors: ['#28C76F', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false,            
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return generico.segundosParaHMS(value);
              }
            }
          },          
          xaxis: {
            categories: ['Abaixo de 50 km/h',  '50 - 60 km/h', '60 - 70 km/h', '70 - 80 km/h', '80 - 90 km/h', 'Acima de 90 km/h'],
            labels: {
              formatter: function (value) {
                return generico.segundosParaHMS(value);
              }
            },  
          },
          title: {
            text: 'Velocidades',
            align: 'center',
            floating: true
          },          
        },
        exibir: false
      },
      graficoRPM: {
        series: [],
        chartOptions: {
          colors: ['#003f5c', '#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'],
          labels: [],          
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          tooltip: {
            y: {
              formatter: function(val) {
                return generico.segundosParaHMS(val/1000);
              }
            }
          },
        } 
      },
      graficoResumo: {
        series: [],
        chartOptions: {
          labels: [],          
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          tooltip: {
            y: {
              formatter: function(val) {
                return generico.segundosParaHMS(val/1000);
              }
            }
          },
        }        
      },      
      listaPercursosDesenhados: [],      
      avisoSelecionado: [],
      labelTabDetalhesPercurso: "DETALHE DO PERCURSO",
      velocidadeAnimacao: 0,
      indiceAtualListaDetalhe: 0,
      configExportExcel: { activePrompt: false, fileName: "", formats:["xlsx", "csv", "txt"] , 
          cellAutoWidth: true, selectedFormat: "xlsx", 
          headerTitle: ["", "Data", "Hora", "Ignição", "Km/h", "Tempo parada", "Motorista", "Endereço", "Recebimento da Transmissão", "Odometro em metros", "Latitude", "Longitude"], 
          headerVal: ["indice", "dataGPS2", "dataRecebimento2", "ignicao", "velocidadeAtual", "tempoParado", "condutor", "descricaoPoI", "recebibidoAs", "odometro", "latitude", "longitude"] 
      },
      popUpCadastroPontoInteresse: {
        exibir: false,
        latitude: null,
        longitude: null  
      },
      exibirGrid: true,
      measure: {
          mvcLine: new window.google.maps.MVCArray(),
          mvcPolygon: new window.google.maps.MVCArray(),
          mvcMarkers: new window.google.maps.MVCArray(),
          line: null,
          polygon: null
      },
      listaPoI: [],
      markersPoI: new Map(),
      gridApiPoi: null,
      gridApiDetalhe: null,
      gridContextPoi: null,      
      columnDefsGridPoI: [
          {
              headerName: 'Grupo',
              field: 'nomeGrupo',
              width: 250,
              filter: true,
          },
          {
              headerName: '',
              field: 'selecionado',
              width: 45,
              cellRendererFramework: BtnAggridComponentRenderer, 
              colId: 'params',
          },
          {
              headerName: 'Nome',
              field: 'nome',
              filter: true,
              width: 375              
          }
      ],
      defaultColDefAgGrid: {
          sortable: true,
          editable: false,
          resizable: true,
          suppressMenu: false          
      },
      marcadoresPoIExibidos: false,
      marcadoresAvisosExibidos: false,
      zoomStart: 9,
      qtdMarkersExibidos: 0,
      poligonoPoISelecionado: null,
      listaPerfisCores: [],
      listaMediaVelocidadeDoPerfil: [],
      listaPercentualVelocidadeDoPerfil: [],

      columnDefsGridDetalhe: [
        { headerName: '#', valueGetter: "node.rowIndex + 1", cellRenderer: function(params) { return "<span style='font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;'>" + (params.node.rowIndex + 1)  + "</span>"}, width: 15   },
        { headerName: '', cellRenderer: function(params) { return "<span style='font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;'>" + params.data.dataGPS2 + "<br/>" + params.data.dataRecebimento2 + (params.data.memoria === "S" ? " <br/> <i title='Informação recuperada da memória do rastreador e recebida às " + params.data.recebibidoAs + "' style='font-size: 13px;' class='material-icons'>info</i>" : "" ) }, width: 45   },
        { headerName: '', cellRenderer: function(params) { 
              let tr = params.data;              
              return '<span style="font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;"><i style="font-size: 12px;" class="material-icons">location_on</i> '+ (tr.descricaoPoI ? tr.descricaoPoI : '') +' </span>' +
                '<br/>' + 
               ( tr.ignicao === 'LIGADO' && tr.velocidadeAtual > 0   ?  '<span style="font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;"><i style="font-size: 12px;" class="text-success material-icons">fiber_manual_record</i> Ligado - ' + tr.velocidadeAtual + ' km/h </span>' : '')  +
               ( tr.ignicao === 'LIGADO' && tr.velocidadeAtual === 0 ?  '<span style="font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;"><i style="font-size: 12px;" class="text-warning material-icons" >fiber_manual_record</i> Parado por ' + tr.tempoParado + ' </span>' : '')  +
               ( tr.ignicao === 'DESLIGADO'                          ?  '<span  style="font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;"><i style="font-size: 12px;" class="text-danger material-icons">fiber_manual_record</i> Desligado por ' + tr.tempoParado + ' </span>' : '')  +
               '<br/> <div style="width:100%; font-size: smaller; font-family: Montserrat, Helvetica, Arial, sans-serif; font-weight: 400;">' + 
                 '<span><i style="font-size: 12px;" class="material-icons">person</i> '+ tr.condutor +' </span>' +
                 (tr.hasOwnProperty('voltagemBateria') ? '<span style="font-size: 9px; float: right; padding-right: 10px"> <i style="font-size: 9px;" class="material-icons">flash_on</i>' + tr.voltagemBateria + 'v</span>': '') +
                 (tr.hasOwnProperty('odometro') ? '<span style="font-size: 9px; float: right; padding-right: 10px"> KM:' + Math.floor(tr.odometro/1000) + '</span>': '') +

                 (tr.hasOwnProperty('distanciaPontoAnterior') ? '<span style="font-size: 9px; float: right; padding-right: 10px"><i style="font-size: 9px;" class="material-icons">more_horiz</i> '+ 
                   (tr.distanciaPontoAnterior < 1000 ? tr.distanciaPontoAnterior + " m" : Math.floor(tr.distanciaPontoAnterior/1000) + " km e " + tr.distanciaPontoAnterior%1000 + " m")                
                 +' </span>' : '') +                 
               '</div>'
          }   },
    ],
      publicPath: process.env.BASE_URL
    }
  },  
  beforeMount() {
    this.gridOptionsDetalhe = { suppressCellSelection: true,  suppressRowClickSelection:false, 
        rowClassRules: {  'item-percurso-memoria': function(params) { return params.data.memoria === 'S'; } } };
    this.gridOptionsPoI = {};
    this.localeTextGridPoI = {
      contains: this.$t('AgGrid_Contains'),
      notContains: this.$t('AgGrid_notContains'),
      startsWith: this.$t('AgGrid_startsWith'),
      endsWith: this.$t('AgGrid_endsWith'),
      andCondition: this.$t('AgGrid_andCondition'),
      orCondition: this.$t('AgGrid_orCondition'),
      filters: this.$t('AgGrid_filters'),
      equals: this.$t('AgGrid_equals'),
      notEqual: this.$t('AgGrid_notEqual'),
      filterOoo: this.$t('AgGrid_filterOoo'),
    };
    this.gridContextPoi = { componentParent: this };      
  },    
  computed: { 
    isAcessoGrupo(){
      return this.$store.getters.isAcessoGrupo;
    },
    isExibirAvisos(){      
      if (this.isAcessoGrupo) {  return this.$store.state.AppActiveUser.permissoes.menuAvisos }
      return true;
    } ,  
    isExibirPerfilVelocidade() {
      //return (this.$store.state.AppActiveUser.idEmpresa === 48 || this.$store.state.AppActiveUser.idEmpresa === 1);
      return true;
    },
    isPermitirAbrirNovoWindow() {
      return (this.$store.state.AppActiveUser.idEmpresa === 1);
    },   
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },    
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.listaConsolidadoPercursos.length
    },
    isParametrosValidos() {
        return this.filtroVeiculoSelecionado !== null && this.filtroDataInicio !== null && this.filtroDataFim !== null;
    },
    isParametrosValidosParaPeriodo() {
      return this.filtroVeiculoSelecionado !== null && this.filtroDataInicio !== null && this.filtroDataFim !== null && Math.ceil((this.filtroDataFim - this.filtroDataInicio) / (3600 * 24)) <= 7;
    },
    getIconPlayPause() {
      if (this.velocidadeAnimacao > 0) {
        return "pause";
      } else {
        return "play_arrow";
      }
    },
    listaDetalhePercursoSelecionadoFiltrada() {
      var self = this;
      var arrayRetorno = self.dadosPercursoSelecionado.lista;

      if (self.filtroVelocidade) {        
        arrayRetorno = arrayRetorno.filter(function (rastreamento) {
            return rastreamento.velocidadeAtual >= self.filtroVelocidade;
        })
      }

      if (self.filtroDistanciaDeslocamento) {        
        arrayRetorno = arrayRetorno.filter(function (rastreamento) {
            if (rastreamento.hasOwnProperty('distanciaPontoAnterior')) {
                return rastreamento.distanciaPontoAnterior >= self.filtroDistanciaDeslocamento;
            } else {
              return false;
            }
        })
      }

      if (self.dadosPercursoSelecionado.chkExibirSohParadas) {        
        arrayRetorno = arrayRetorno.filter(function (rastreamento) {
                if ( rastreamento.ignicao === "LIGADO" && parseInt(rastreamento.velocidadeAtual) > 0 ) {                    
                  return false; 
                } else if (rastreamento.ignicao === "LIGADO" ||  rastreamento.ignicao === "DESLIGADO") {			
                
                  // Tempo da parada de acordo com o tempo mínimo.
                  if (parseInt(rastreamento.tempoParadoEmMilisegundos) >= self.tempoMinimoParada*60*1000) {
                      return true;
                  }else {
                      return false;
                  }
                
                }
                return false;
        })
      }
      return arrayRetorno;
    },
    getPercentualEncontradoEndereco() {
       return (this.indiceAtualListaDetalhe / this.dadosPercursoSelecionado.lista.length) * 100;
    },
    qtdPoiSelecionado() {
        if (this.listaPoI && this.listaPoI.length > 0) {
            return this.listaPoI.filter(x => x.selecionado).length;
        }

        return 0;
    }
  },
  methods: { 
    clickExibirFaixasHorario(){
        this.dadosPopUpParametroHora.exibirOutrasFaixasHorario = !this.dadosPopUpParametroHora.exibirOutrasFaixasHorario
        if (this.dadosPopUpParametroHora.exibirOutrasFaixasHorario) {
            this.dadosPopUpParametroHora.filtroHoraInicio = "0800";
            this.dadosPopUpParametroHora.filtroHoraFim = "0859";        
        } else {
          this.dadosPopUpParametroHora.filtroHoraInicio = "0000";
            this.dadosPopUpParametroHora.filtroHoraFim = "2359";        
        }
    },
    getCorMarcaModulo(marcaModulo) {
      return generico.getCorMarcaModulo(marcaModulo);
    },
    onGridReadyDetalhe(params) {
      this.gridApiDetalhe = params.api;
      this.gridApiDetalhe.sizeColumnsToFit(); 
    }, 
    isRastreadorSubstituidp(tr){
      if (this.filtroVeiculoSelecionado.codigoModulo) {
        if (tr.codigoModulo !== this.filtroVeiculoSelecionado.codigoModulo && tr.codigoModulo !== this.filtroVeiculoSelecionado.codigoModuloBkp) {
          return true;
        }
      } 
      return false;

    },
    exibirMarcadorDaVelocidade(i) {
      this.arrMarkerTodosPercursos[i].setAnimation(window.google.maps.Animation.BOUNCE);
      window.google.maps.event.trigger(this.arrMarkerTodosPercursos[i], 'click');                             
      this.map.setCenter(this.arrMarkerTodosPercursos[i].position);
      this.map.setZoom(20);	
    },
    deselecionarTodosPoi() {
        if (this.qtdPoiSelecionado !==  this.gridApiPoi.getSelectedNodes().length) {
            let titulo = null;
            let marcadorExistente = null;
            let self_ = this;
            this.gridApiPoi.forEachNodeAfterFilter(function (node) {
                node.data.selecionado = false;
                titulo = node.data.nomeGrupo + " - " + node.data.nome + (node.data.hasOwnProperty("codigo") && node.data.codigo !== "" ? " - " + node.data.codigo : "");
                marcadorExistente = self_.markersPoI.get(titulo);
                if (marcadorExistente) {
                  marcadorExistente.setMap(null);
                  self_.markersPoI.delete(titulo);
              }
            });
            this.gridApiPoi.refreshCells();  
            this.marcadoresPoIExibidos = false;
        } else {
            this.gridApiPoi.deselectAll();
        }
    },        
    onSelectionChangedPoI(event) {
        event.api.refreshCells();            
    },
    onGridReadyPoi(params) {
        this.gridApiPoi = params.api;
        this.gridApiPoi.sizeColumnsToFit(); 
    },
    desenharPoligonoPoI(poi) {      
      if (this.poligonoPoISelecionado) {
        this.poligonoPoISelecionado.setMap(null);
        this.poligonoPoISelecionado = null;
      }

      if (!poi.poligonoPoIJSON) {              
        var raioInicioConfig = {
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: this.map,
            center: this.$refs.gmc.getLatLng(poi.latitude, poi.longitude),
            radius: parseFloat(poi.raio)*1000
        };

        this.poligonoPoISelecionado = new window.google.maps.Circle(raioInicioConfig);        
      } else {        
        var listaPontos = JSON.parse(poi.poligonoPoIJSON);
        var latLong = null;            
        var coordenadasPoligono = [];
        //Não desenhar o ultimo ponto, pois serve para fechar o poligono
        for(var i=0; i < listaPontos.length - 1; i++) {                
            latLong = new window.google.maps.LatLng(parseFloat(listaPontos[i].lat), parseFloat(listaPontos[i].long));                                                
            coordenadasPoligono.push(latLong);
        }

        this.poligonoPoISelecionado = new window.google.maps.Polygon({
          path: coordenadasPoligono,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 1.0,
          strokeWeight: 2              
        });

        this.poligonoPoISelecionado.setMap(this.map);           
      } 
    },
    onRowClickedPoI(event) {
        let poi = event.node.data;
        let location = this.$refs.gmc.getLatLng(poi.latitude, poi.longitude);
        this.map.setZoom(15);
        this.map.panTo(location);
        let titulo = poi.nomeGrupo + " - " + poi.nome + (poi.hasOwnProperty("codigo") && poi.codigo !== "" ? " - " + poi.codigo : "");
        let marcadorExistente = this.markersPoI.get(titulo);
        if (marcadorExistente) {
            marcadorExistente.setAnimation(null);
            marcadorExistente.setAnimation(window.google.maps.Animation.BOUNCE);   
            this.desenharPoligonoPoI(poi);                     
        }
    },
    onRowSelectedPoI(event) {
        let poi = event.node.data;
        let titulo = poi.nomeGrupo + " - " + poi.nome + (poi.hasOwnProperty("codigo") && poi.codigo !== "" ? " - " + poi.codigo : "");
        let marcadorExistente = this.markersPoI.get(titulo);

        if (event.node.selected) {
          if (!marcadorExistente) {
            this.plotarPoiNoMapa(event.node.data);            
          }
          this.desenharPoligonoPoI(poi);
        } else {
            if (marcadorExistente) {
                marcadorExistente.setMap(null);
                this.markersPoI.delete(titulo);
                if (this.poligonoPoISelecionado) {
                  this.poligonoPoISelecionado.setMap(null);
                  this.poligonoPoISelecionado = null;
                }
            }
        }

        event.node.data.selecionado = event.node.selected;
    },
    fecharPopUpPontoInteresse() {
      this.popUpCadastroPontoInteresse.exibir = false;
    },
    click_AbrirPopUpCriarPoI(latitude, longitude) {
        this.popUpCadastroPontoInteresse.latitude = latitude;
        this.popUpCadastroPontoInteresse.longitude = longitude;
        this.popUpCadastroPontoInteresse.exibir = true;
    },     
    classCorPercurso: function (tr) {
      return {
        'w-3': true,
        'h-3': true,
        'fill-current': true,
        'cor1Percurso': tr.cor === '#FD3434',
        'cor2Percurso': tr.cor === '#3B34FD',
        'cor3Percurso': tr.cor === '#000000',
        'cor4Percurso': tr.cor === '#98998E',
        'cor5Percurso': tr.cor === '#D1E607',
      }
    },     
    fetchListaAviso(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS) { 
        

        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idVeiculo', this.filtroVeiculoSelecionado.idVeiculo);
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        params.append('dataHoraInicio', dataInicioYYYYMMDDHHMMSS);
        params.append('dataHoraFim', dataFimYYYYMMDDHHMMSS);
                        
        axios.post("/ListarAvisosVeiculoClientePorData", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                // Efetuar logoff
                this.$router.push({ path: '/login' });                     
            } else {
                if (this.chkApagarAnterior) {
                    for(var i = 0; i < this.arrMarkerAvisos.length; i++) {
                        this.arrMarkerAvisos[i].setMap(null);
                    }
                    this.arrMarkerAvisos = null;
                    this.arrMarkerAvisos = [];
                }

                if (response.data.hasOwnProperty("lista")) {                    
                    this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = response.data.lista;
                    if (this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado.length > 0) {
                      
                      this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado.forEach((aviso) => {                                              
                          this.addMarkerAviso(aviso);                    
                      }); 

                      this.marcadoresAvisosExibidos = true;
                      
                    } else {
                      this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = null;
                      this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = [];      
                      this.marcadoresAvisosExibidos = false;                
                    }
                } else {
                    this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = null;
                    this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = [];                                     
                    this.marcadoresAvisosExibidos = false;
                }
                
                this.listaPercursosDesenhados.push(JSON.parse(JSON.stringify(this.dadosPercursoSelecionado)));                 
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaAviso - " + error); 
        })    
                        
    },      
    addMarkerAviso(aviso) {
      var location = this.$refs.gmc.getLatLng(aviso.latitude, aviso.longitude);
      
      var marker1 = new window.MarkerWithLabel({
        position: location,
          title: aviso.tipoDescricao + '\n' + aviso.condutor + '\n' + aviso.descricao + '\n' + aviso.dataHora,                           
          map: this.map,                    
          labelAnchor: new window.google.maps.Point(10, 20),       
          labelStyle: {opacity: 1} ,          
          icon: { url: this.publicPath + 'imagens/iconesAvisos/dot' + aviso.tipo + '.png'} 
      });  
                  
      this.arrMarkerAvisos.push(marker1);
      
      return marker1;
    },
    exibirAvisoSelecionado(aviso) {                 
      var tituloClicado = aviso.tipoDescricao + '\n' + aviso.condutor + '\n' + aviso.descricao + '\n' + aviso.dataHora;
      var marcadores = this.arrMarkerAvisos; 
      var location = this.$refs.gmc.getLatLng(aviso.latitude, aviso.longitude);
      this.map.setCenter(location);
      this.map.setZoom(25);
      if ( marcadores.length > 0 ) {                
          for(var i=0; i < marcadores.length;i++) {
              if (marcadores[i].getTitle() === tituloClicado ) {                                            
                  marcadores[i].setAnimation(window.google.maps.Animation.BOUNCE);
              } else {
                  marcadores[i].setAnimation(null);
              }
          }
      }  
    },     
    fetchVeiculos() {
      this.$vs.loading();
      const params = new URLSearchParams();
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('funcionalidade', 'PERCURSOS');

      axios.get("/RecuperarVeiculosAtivosCliente", {
              params , 
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
        if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {            
            this.$router.push({ path: '/login' });  // Efetuar logoff
        } else {
            this.listaVeiculos = response.data;        
        }
        this.$vs.loading.close();
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchVeiculos - " + error); 
      })       

    },     
    fetchListaConsolidado() { 
      
        if (!this.filtroVeiculoSelecionado || !this.filtroVeiculoSelecionado.idVeiculo) {
          this.listaConsolidadoPercursos = null;
          this.listaConsolidadoPercursos = [];
          return;
        }
        this.$vs.loading();

        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idVeiculo', this.filtroVeiculoSelecionado.idVeiculo);
        params.append('idCliente', this.$store.state.AppActiveUser.id);

        let dataInicioYYYYMMDDHHMMSS = this.getYMD(this.filtroDataInicio) + this.filtroHoraInicio + '00';
        let dataFimYYYYMMDDHHMMSS = this.getYMD(this.filtroDataFim) + this.filtroHoraFim + '59';
        
        params.append('dataRecebimentoInicio', dataInicioYYYYMMDDHHMMSS);
        params.append('dataRecebimentoFim', dataFimYYYYMMDDHHMMSS);
        
        axios.post("/ListarResumoRastreamentoVeiulo", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {                                
                this.listaConsolidadoPercursos = response.data;
                this.tabGeral = 0;                
                if (this.listaConsolidadoPercursos.length > 0) {
                  this.exibirMensagemNenhumDadoEncontrado = false;
                } else {
                  this.listaConsolidadoPercursos = null;
                  this.listaConsolidadoPercursos = [];
                  this.exibirMensagemNenhumDadoEncontrado = true;                    
                }

                if (this.$store.getters.dadosParaPercurso.consolidadoPercursoSelecionado) {                    
                    this.fetchRastreamento();
                }

                this.$store.commit('SET_DADOS_PARA_PERCURSO', { filtroVeiculoSelecionado: null, consolidadoPercursoSelecionado: null, dadosPopUpParametroHora: null});
                
            }
        }).catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaAviso - " + error); 
        })    
                        
    },         
    pesquisarVeiculo(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (veiculo) {
              return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
              ) ;
      })
    },    
    getYMD(tempoEmSegundos) {
      var d = new Date(tempoEmSegundos*1000),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
  
      return year + '' + month + '' + day;
    },
    set7Dias() {
      this.filtroDataInicio = String(new Date().fp_incr(-7).getTime()/1000);
      this.filtroDataFim = String(new Date().getTime() / 1000);
    },
    setOntem() {
      this.filtroDataInicio = String(new Date().fp_incr(-1).getTime()/1000);
      this.filtroDataFim = String(new Date().getTime() / 1000);
    },
    setHoje() {
      this.filtroDataInicio = String(new Date().getTime()/1000);
      this.filtroDataFim = String(new Date().getTime() / 1000);
    },
    isHorarioPreenchido(horarioInicio, horarioFim){
      if (horarioInicio === null || horarioFim === null) {
        return false;
      }
      
      return true;
    },
    isHorarioValido(horaInicio, horaFim) {
      let intHoraInicio = parseInt(horaInicio);
      let intHoraFim = parseInt(horaFim);
      if (intHoraInicio > intHoraFim ) {
        return false;
      }
      
      return true;
    },
    fetchRastreamentoMultiplosHorariosStart() { 

      if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtroHoraInicio, this.dadosPopUpParametroHora.filtroHoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtroHoraInicio, this.dadosPopUpParametroHora.filtroHoraFim) === false) {
          this.$vs.notify({title: 'Horário 1 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      } 
      if ( this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro2HoraInicio, this.dadosPopUpParametroHora.filtro2HoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtro2HoraInicio, this.dadosPopUpParametroHora.filtro2HoraFim) === false) {
          this.$vs.notify({title: 'Horário 2 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      } 
      if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro3HoraInicio, this.dadosPopUpParametroHora.filtro3HoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtro3HoraInicio, this.dadosPopUpParametroHora.filtro3HoraFim) === false) {
          this.$vs.notify({title: 'Horário 3 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      } 
      
      if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro4HoraInicio, this.dadosPopUpParametroHora.filtro4HoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtro4HoraInicio, this.dadosPopUpParametroHora.filtro4HoraFim) === false) {
          this.$vs.notify({title: 'Horário 4 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      } 
      if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro5HoraInicio, this.dadosPopUpParametroHora.filtro5HoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtro5HoraInicio, this.dadosPopUpParametroHora.filtro5HoraFim) === false) {
          this.$vs.notify({title: 'Horário 5 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      } 
      if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro6HoraInicio, this.dadosPopUpParametroHora.filtro6HoraFim) && this.isHorarioValido(this.dadosPopUpParametroHora.filtro6HoraInicio, this.dadosPopUpParametroHora.filtro6HoraFim) === false) {
          this.$vs.notify({title: 'Horário 6 inválido', text: 'O horário de início deve ser menor que o horário de fim.', color: 'danger',position: 'top-center', iconPack: 'material', icon: 'warning' });
        return;
      }
      this.dadosPopUpParametroHora.limpouAnteriores = false;
      this.$vs.loading();
      this.fetchRastreamentoMultiplosHorarios();

    },
    fetchRastreamentoMultiplosHorarios() { 
      
      let dataInicioYYYYMMDDHHMMSS = null;
      let dataFimYYYYMMDDHHMMSS = null;

      if (this.dadosPopUpParametroHora.indiceFaixa < 6) {
        if (this.dadosPopUpParametroHora.indiceFaixa === 1) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtroHoraInicio, this.dadosPopUpParametroHora.filtroHoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else if (this.dadosPopUpParametroHora.indiceFaixa === 2) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro2HoraInicio, this.dadosPopUpParametroHora.filtro2HoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro2HoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro2HoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else if (this.dadosPopUpParametroHora.indiceFaixa === 3) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro3HoraInicio, this.dadosPopUpParametroHora.filtro3HoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro3HoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro3HoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else if (this.dadosPopUpParametroHora.indiceFaixa === 4) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro4HoraInicio, this.dadosPopUpParametroHora.filtro4HoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro4HoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro4HoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else if (this.dadosPopUpParametroHora.indiceFaixa === 5) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro5HoraInicio, this.dadosPopUpParametroHora.filtro5HoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro5HoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro5HoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else if (this.dadosPopUpParametroHora.indiceFaixa === 6) {
          if (this.isHorarioPreenchido(this.dadosPopUpParametroHora.filtro6HoraInicio, this.dadosPopUpParametroHora.filtro6HoraFim)) {
            dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro6HoraInicio + '00';
            dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtro6HoraFim + '59';
          } else {
            this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
            this.fetchRastreamentoMultiplosHorarios();
            return;
          }
        } else {
          this.$vs.loading.close();      
          this.dadosPopUpParametroHora.indiceFaixa = 1;
          this.exibirPopUpParametroHora  = false;
          this.tabGeral = 0;
          this.chkApagarAnterior = true;  
          return;
        }
      } else {
        this.$vs.loading.close();      
        this.dadosPopUpParametroHora.indiceFaixa = 1;
        this.exibirPopUpParametroHora  = false;
        this.tabGeral = 0;
        this.chkApagarAnterior = true;  
        return;
      }
      
      let idVeiculo = this.consolidadoPercursoSelecionado.idVeiculo;
      let codigoModulo = this.consolidadoPercursoSelecionado.codigoModulo;
      let marcaModulo = this.consolidadoPercursoSelecionado.marcaModulo;
      let exibirPercursoBkp = this.dadosPopUpParametroHora.exibirPercursoBkp;
      let somenteModuloParametro = true;
      let exportarParaKLM = false;

      if (!this.dadosPopUpParametroHora.limpouAnteriores) {
          this.dadosPopUpParametroHora.limpouAnteriores = true;
          this.chkApagarAnterior = true;  
      } else {
        this.chkApagarAnterior = false;  
      }
            
      this.fetchRastreamentoGenerico(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS, idVeiculo, codigoModulo, marcaModulo, this.chkExibirSohParadas, this.chkExibirMakerEmMovimento, exibirPercursoBkp, somenteModuloParametro, exportarParaKLM);  
      
    },
    fetchPeriodoRastreamento() { 
      let dataInicioYYYYMMDDHHMMSS = this.getYMD(this.filtroDataInicio) + this.filtroHoraInicio + '00';
      let dataFimYYYYMMDDHHMMSS = this.getYMD(this.filtroDataFim) + this.filtroHoraFim + '59';
      let idVeiculo = this.filtroVeiculoSelecionado.idVeiculo;
      let codigoModulo = this.filtroVeiculoSelecionado.codigoModulo;
      let marcaModulo = this.filtroVeiculoSelecionado.marcaModulo;
      this.consolidadoPercursoSelecionado = {idVeiculo: idVeiculo, codigoModulo: codigoModulo, marcaModulo: marcaModulo, dataYYYYMMDD: this.getYMD(this.filtroDataInicio),
        dataInicioYYYYMMDDHHMMSS: dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS: dataFimYYYYMMDDHHMMSS
      };
      let exibirPercursoBkp = false;
      let somenteModuloParametro = false;
      let exportarParaKLM = false;
      this.$vs.loading();
      this.fetchRastreamentoGenerico(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS, idVeiculo, codigoModulo, marcaModulo, this.chkExibirSohParadasOuter, exibirPercursoBkp, somenteModuloParametro, exportarParaKLM);  
    },
    fetchRastreamento() { 
      
      let dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraInicio + '00';
      let dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraFim  + '59';
      let idVeiculo = this.consolidadoPercursoSelecionado.idVeiculo;
      let codigoModulo = this.consolidadoPercursoSelecionado.codigoModulo;
      let marcaModulo = this.consolidadoPercursoSelecionado.marcaModulo;
      let exibirPercursoBkp = this.dadosPopUpParametroHora.exibirPercursoBkp;
      let somenteModuloParametro = true;
      let exportarParaKLM = false;
      if (this.chkAbrirNovaJanela) {
          this.routePercursoNovaWindow();
      } else {
          this.$vs.loading();
          this.fetchRastreamentoGenerico(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS, idVeiculo, codigoModulo, marcaModulo, this.chkExibirSohParadas, this.chkExibirMakerEmMovimento, exibirPercursoBkp, somenteModuloParametro, exportarParaKLM);  
      }
    },
    fetchRastreamentoGenerico(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS, idVeiculo, codigoModulo, marcaModulo, exibirDistanciaEntreParadas, naoExibirMakerEmMovimento, exibirPercursoBkp, somenteModuloParametro, exportarParaKLM) { 
      
      const params = new URLSearchParams();
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('idVeiculo', idVeiculo);
      params.append('codigoModulo', codigoModulo);
      params.append('marcaModulo', marcaModulo);
      params.append('condutor', this.filtroVeiculoSelecionado.condutor);      
      params.append('dataRecebimentoInicio', dataInicioYYYYMMDDHHMMSS);
      params.append('dataRecebimentoFim', dataFimYYYYMMDDHHMMSS);
      params.append('tempoMinimoParada', this.tempoMinimoParada);
      params.append('exibirDistanciaEntreParadas', exibirDistanciaEntreParadas);
      params.append('exibirPercursoBackup', exibirPercursoBkp);
      params.append('somenteModuloParametro', somenteModuloParametro);

      if (exportarParaKLM) {
        params.append('exportarParaKLM', true);
        if (this.perfilVelocidade) {
          params.append('idPerfilCoresVelocidade', this.perfilVelocidade.id);
        }
      }
            
      axios.post("/RastrearVeiculosClientePorData", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$vs.loading.close();
              this.$router.push({ path: '/login' });  // Efetuar logoff
          } else { 
              if  (exportarParaKLM) { 
                this.$vs.loading.close();
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Percurso' + this.dadosPercursoSelecionado.resumo.placaVeiculo + '.kml');
                document.body.appendChild(fileLink);
                fileLink.click(); 
              } else {
                  if (this.chkApagarAnterior) {
                    
                    this.limparMarcadoresEPolylineTodosRastreamentos();
                    
                    this.listaPercursosDesenhados = null;
                    this.listaPercursosDesenhados = [];  

                    this.quebraPorZoom.length = 0;

                    this.quebraPorZoom = [];
                    this.quebraPorZoom.push([]);
                    this.quebraPorZoom.push([]);
                    this.quebraPorZoom.push([]);
                    this.quebraPorZoom.push([]);
                    this.quebraPorZoom.push([]);
                          
                  } 

                  this.dadosPercursoSelecionado = response.data 
                  this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = null;
                  this.dadosPercursoSelecionado.listaAvisosPercursosSelecionado = [];

                  if (this.dadosPercursoSelecionado.lista.length > 0 ) {
                    this.carregarDadosRastreamento();   
                  }
                  
                  this.arrMarkerPercurso = null;
                  this.arrMarkerPercurso = [];

                  this.dadosPercursoSelecionado.cor = this.listaCoresPercurso[this.listaPercursosDesenhados.length];
                  this.dadosPercursoSelecionado.chkExibirSohParadas = exibirDistanciaEntreParadas;
                  this.dadosPercursoSelecionado.chkExibirMakerEmMovimento = naoExibirMakerEmMovimento;
                  this.dadosPercursoSelecionado.exibirPercursoBkp = exibirPercursoBkp;
                  if (this.dadosPercursoSelecionado.lista.length > 0 ) {
                    this.desenharRastreamento();              
                    this.arrPolylines.push(...this.desenharPolyline());
                    this.centralizarPercurso(); 
                    this.fetchListaAviso(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS);   
                    this.zoomStart = this.map.getZoom();
                  }
                  
                  this.consolidadoPercursoSelecionado.cor = this.listaCoresPercurso[this.listaPercursosDesenhados.length];  
                  
                  if (!this.dadosPopUpParametroHora.exibirOutrasFaixasHorario) {
                    this.$vs.loading.close();      
                    if (this.dadosPercursoSelecionado.lista.length === 0 ) {
                      this.$vs.dialog({ color: 'danger', title: 'Atenção', text: 'Sem informações de percurso para o período', acceptText: 'OK'})
                    }
                  }

                  if (this.dadosPopUpParametroHora.exibirOutrasFaixasHorario && this.dadosPopUpParametroHora.indiceFaixa < 6) {
                    this.dadosPopUpParametroHora.indiceFaixa = this.dadosPopUpParametroHora.indiceFaixa + 1;
                    this.fetchRastreamentoMultiplosHorarios();
                  } else if (this.dadosPopUpParametroHora.exibirOutrasFaixasHorario && this.dadosPopUpParametroHora.indiceFaixa === 6) {
                     this.exibirPopUpParametroHora  = false;
                  } else {
                    this.exibirPopUpParametroHora  = false;
                  }
              }
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchRastreamento - " + error); 
      })                          
    }, 
    carregarDadosRastreamento() {          
          let vetResumoVelocidade = [];          
          let algumTempoPositivo = false;

          for(var i=0; i < this.dadosPercursoSelecionado.resumo.resumoVelocidade.length;i++) {            
            vetResumoVelocidade.push(this.dadosPercursoSelecionado.resumo.resumoVelocidade[i].tempoEmSegundos);                 
            if (this.dadosPercursoSelecionado.resumo.resumoVelocidade[i].tempoEmSegundos > 0) {
              algumTempoPositivo = true;
            }
          }   

          if (algumTempoPositivo) {          
            this.graficoVelocidades.exibir = true;
          }  else  {
            this.graficoVelocidades.exibir = false;
          }

          this.graficoVelocidades.series = [{name: "", data: vetResumoVelocidade }];

          this.graficoRPM.series = null;
          this.graficoRPM.series = [];
          this.graficoRPM.chartOptions.labels = null;
          this.graficoRPM.chartOptions.labels = [];

          if (this.dadosPercursoSelecionado.resumo.hasOwnProperty("resumoRpm")) {                
            for(var j=0; j < this.dadosPercursoSelecionado.resumo.resumoRpm.length; j++) {                                    
              this.graficoRPM.series.push(this.dadosPercursoSelecionado.resumo.resumoRpm[j].tempoEmSegundos*1000);
              this.graficoRPM.chartOptions.labels.push(this.dadosPercursoSelecionado.resumo.resumoRpm[j].faixa);
            }                   
          } 
          this.graficoResumo.series = null;
          this.graficoResumo.series = [];
          this.graficoResumo.chartOptions.labels = null;
          this.graficoResumo.chartOptions.labels = [];
          this.graficoResumo.series.push(this.dadosPercursoSelecionado.resumo.tempoParadoLigadoEmMili); 
          this.graficoResumo.chartOptions.labels.push("Tempo Parado ligado");
          this.graficoResumo.series.push(this.dadosPercursoSelecionado.resumo.tempoDesligadoEmMili);  
          this.graficoResumo.chartOptions.labels.push("Tempo Desligado");
          this.graficoResumo.series.push(this.dadosPercursoSelecionado.resumo.tempoEmMovimentoEmMili);  
          this.graficoResumo.chartOptions.labels.push("Tempo Em Movimento");

          this.tabGeral = 1;
          if (this.dadosPercursoSelecionado.lista.length === 0 ) {
            this.labelTabDetalhesPercurso = "DETALHE DO PERCURSO";
          } else {
            this.labelTabDetalhesPercurso = this.dadosPercursoSelecionado.resumo.placaVeiculo + " " + this.dadosPercursoSelecionado.resumo.periodo;
            this.configExportExcel.fileName = "Percurso " + this.dadosPercursoSelecionado.resumo.placaVeiculo;
          }

          if (this.dadosPercursoSelecionado.hasOwnProperty("coordenadas")) {
              this.centralizarPercurso();
          }
    },
    desenharRastreamento() {                   
        var dadosDoVeiculo = this.dadosPercursoSelecionado.resumo.marcaVeiculo + " " + this.dadosPercursoSelecionado.resumo.modeloVeiculo;
        dadosDoVeiculo = dadosDoVeiculo + " - " + (this.dadosPercursoSelecionado.resumo.labelVeiculo ? this.dadosPercursoSelecionado.resumo.labelVeiculo :  this.dadosPercursoSelecionado.resumo.placaVeiculo );

        let indiceQuebraPorZoom = -1;
        let divisor = parseInt(this.dadosPercursoSelecionado.lista.length / 200);
        if (divisor > 5 ) { divisor = 5;} // Só 5 niveis de zoom
        if (divisor === 0 ) { divisor = 1;} // Pelo menos 1 nivel de zoom
        
        let listaCategorias = [];
        let dadosVelocidade = [];

        this.listaMediaVelocidadeDoPerfil = [];
        this.listaPercentualVelocidadeDoPerfil = [];
        let listaVelocidadesFaixa1 = [];
        let listaVelocidadesFaixa2 = [];
        let listaVelocidadesFaixa3 = [];
        let listaVelocidadesFaixa4 = [];
        let listaVelocidadesFaixaNenhuma = [];

        let mediaVelocidadeFaixa1 = 0;
        let mediaVelocidadeFaixa2 = 0;
        let mediaVelocidadeFaixa3 = 0;
        let mediaVelocidadeFaixa4 = 0;
        let mediaVelocidadeFaixaNenhuma = 0;

        let velocidadeAtual = 0;
        for (var j=0; j < this.dadosPercursoSelecionado.lista.length; j++ ) { 	  			            
          velocidadeAtual = parseFloat(this.dadosPercursoSelecionado.lista[j].velocidadeAtual);
          indiceQuebraPorZoom = j % divisor;          
          this.addMarkerPonto(this.dadosPercursoSelecionado.lista[j], dadosDoVeiculo, indiceQuebraPorZoom);        
          listaCategorias.push(this.dadosPercursoSelecionado.lista[j].dataHoraGPS2);  
          dadosVelocidade.push(velocidadeAtual);  

          if (this.perfilVelocidade) {
              if (velocidadeAtual >= parseFloat(this.perfilVelocidade.velocidadeFaixa1Inicio) && velocidadeAtual <= parseFloat(this.perfilVelocidade.velocidadeFaixa1Fim)) {
                listaVelocidadesFaixa1.push(velocidadeAtual);               
              } else if (velocidadeAtual >= parseFloat(this.perfilVelocidade.velocidadeFaixa2Inicio) && velocidadeAtual <= parseFloat(this.perfilVelocidade.velocidadeFaixa2Fim)) {
                listaVelocidadesFaixa2.push(velocidadeAtual);                
              } else if (velocidadeAtual >= parseFloat(this.perfilVelocidade.velocidadeFaixa3Inicio) && velocidadeAtual <= parseFloat(this.perfilVelocidade.velocidadeFaixa3Fim)) {
                listaVelocidadesFaixa3.push(velocidadeAtual);                
              } else if (this.perfilVelocidade.velocidadeFaixa4Inicio && velocidadeAtual >= parseFloat(this.perfilVelocidade.velocidadeFaixa4Inicio) && velocidadeAtual <= parseFloat(this.perfilVelocidade.velocidadeFaixa4Fim)) {
                listaVelocidadesFaixa4.push(velocidadeAtual);                
              } else if (velocidadeAtual > 0 ) {
                listaVelocidadesFaixaNenhuma.push(velocidadeAtual);                
              }
          }
        }  
        
        if (listaVelocidadesFaixa1.length > 0) {
          const soma = listaVelocidadesFaixa1.reduce((acumulador, valor) => acumulador + valor, 0);
          mediaVelocidadeFaixa1 = soma / listaVelocidadesFaixa1.length;
        }

        if (listaVelocidadesFaixa2.length > 0) {
          const soma = listaVelocidadesFaixa2.reduce((acumulador, valor) => acumulador + valor, 0);
          mediaVelocidadeFaixa2 = soma / listaVelocidadesFaixa2.length;
        }

        if (listaVelocidadesFaixa3.length > 0) {
          const soma = listaVelocidadesFaixa3.reduce((acumulador, valor) => acumulador + valor, 0);
          mediaVelocidadeFaixa3 = soma / listaVelocidadesFaixa3.length;
        }

        if (listaVelocidadesFaixa4.length > 0) {
          const soma = listaVelocidadesFaixa4.reduce((acumulador, valor) => acumulador + valor, 0);
          mediaVelocidadeFaixa4 = soma / listaVelocidadesFaixa4.length;
        }

        if (listaVelocidadesFaixaNenhuma.length > 0) {
          const soma = listaVelocidadesFaixaNenhuma.reduce((acumulador, valor) => acumulador + valor, 0);          
          mediaVelocidadeFaixaNenhuma = soma / listaVelocidadesFaixaNenhuma.length;
        }

        let qtdPontosVelocidade = listaVelocidadesFaixa1.length + listaVelocidadesFaixa2.length + listaVelocidadesFaixa3.length + listaVelocidadesFaixa4.length + listaVelocidadesFaixaNenhuma.length;

        this.listaMediaVelocidadeDoPerfil.push(generico.formatar2Digitos(mediaVelocidadeFaixa1));
        this.listaMediaVelocidadeDoPerfil.push(generico.formatar2Digitos(mediaVelocidadeFaixa2));
        this.listaMediaVelocidadeDoPerfil.push(generico.formatar2Digitos(mediaVelocidadeFaixa3));
        this.listaMediaVelocidadeDoPerfil.push(generico.formatar2Digitos(mediaVelocidadeFaixa4));
        this.listaMediaVelocidadeDoPerfil.push(generico.formatar2Digitos(mediaVelocidadeFaixaNenhuma));

        this.listaPercentualVelocidadeDoPerfil.push(generico.formatar2Digitos((listaVelocidadesFaixa1.length/qtdPontosVelocidade)*100));
        this.listaPercentualVelocidadeDoPerfil.push(generico.formatar2Digitos((listaVelocidadesFaixa2.length/qtdPontosVelocidade)*100));
        this.listaPercentualVelocidadeDoPerfil.push(generico.formatar2Digitos((listaVelocidadesFaixa3.length/qtdPontosVelocidade)*100));
        this.listaPercentualVelocidadeDoPerfil.push(generico.formatar2Digitos((listaVelocidadesFaixa4.length/qtdPontosVelocidade)*100));
        this.listaPercentualVelocidadeDoPerfil.push(generico.formatar2Digitos((listaVelocidadesFaixaNenhuma.length/qtdPontosVelocidade)*100));
        
        this.graficoVelocidadesLinha.series = [{ name: 'Velocidade ( km/h )', data: dadosVelocidade}];
        this.graficoVelocidadesLinha.chartOptions.xaxis = { labels: {  show: false,  style: {fontSize: '8px'} },
         categories : listaCategorias };
        
        this.arrMarkerTodosPercursos = this.arrMarkerTodosPercursos.concat(this.arrMarkerPercurso); 	     

        if (dadosVelocidade.length > 1500) {
          this.exibirGraficoVelocidadesLinha = false;
        } else {
          this.exibirGraficoVelocidadesLinha = true;
        }
    },
    addMarkerPonto(itemPercurso, dadosDoVeiculo, indiceQuebraPorZoom) {      
      let _self = this;
      var numero;
      var marker1;
      var cor = '#84b741';
      var corStrokeMemoria = '#ffffff';
      var strokeWeightMemoria = 0;
      var plotarNoMapa = true;
      var isExibirOrdem = this.chkExibirOrdem;
      var classeCss = null;
      var tempoParadoOuVelocidade = null;
      var vVisible = true;

      if (this.chkExibirSohParadas) {
        if (itemPercurso.tempoParadoEmMilisegundos >= this.tempoMinimoParada*60*1000) {
          plotarNoMapa = true;
        } else {
          plotarNoMapa = false;
        }
      }

      if (itemPercurso.memoria === 'S') {
        strokeWeightMemoria = 2;
      }

      if (itemPercurso.ignicao === 'LIGADO' && itemPercurso.velocidadeAtual > 0) {
          tempoParadoOuVelocidade = itemPercurso.velocidadeAtual + " km/h";
          if (itemPercurso.memoria === 'S') {          
            classeCss = "labelPercusoLigadoEmMovimentoMemoria";
          } else {
            classeCss = "labelPercusoLigadoEmMovimento";
          }
          cor = '#84b741';       
          if (!this.chkExibirMakerEmMovimento && plotarNoMapa) {
            plotarNoMapa = false;
          } else if (indiceQuebraPorZoom > 0 && plotarNoMapa) {
            vVisible = false;
          }  
      } else if (itemPercurso.ignicao === 'LIGADO') {
          tempoParadoOuVelocidade = "parada de " + itemPercurso.tempoParado;
          if (itemPercurso.memoria === 'S') {          
            classeCss = "labelPercursoLigadoEmParadoMemoria";
          } else {
            classeCss = "labelPercursoLigadoEmParado";
          }
          cor = '#f6f572';
      } else {
          tempoParadoOuVelocidade = "parada de " +  itemPercurso.tempoParado;
          if (itemPercurso.memoria === 'S') {          
            classeCss = "labelPercursoDesligadoMemoria";
          } else {
            classeCss = "labelPercursoDesligado";
          }
          cor = '#ff0000'; 
      }
      
      var icone = {path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, rotation: parseFloat(itemPercurso.orientacao), scale: 4, strokeWeight: strokeWeightMemoria, strokeColor: corStrokeMemoria, fillColor: cor, fillOpacity: 1};
      var latlng = this.$refs.gmc.getLatLng(itemPercurso.latitude, itemPercurso.longitude);

      if (itemPercurso.indice === 1) {
          icone = {url:  this.publicPath + "imagens/inicio.png"};
          numero = "INICIO - " + itemPercurso.indice;
      } else if (this.dadosPercursoSelecionado.lista.length === itemPercurso.indice) {
          icone =  {url: this.publicPath + "imagens/fim.png"};
          numero = "FIM - " + itemPercurso.indice;
      } else {
          numero = "" + itemPercurso.indice;
      }
      
      if (plotarNoMapa) {
        if (isExibirOrdem) {
          marker1 = new window.MarkerWithLabel({
              position: latlng,                                          
              map: this.map,
              labelContent: numero,
              labelAnchor: new window.google.maps.Point(24, 34),
              labelClass: classeCss, 
              labelStyle: {opacity: 1},
              visible: vVisible,
              icon: icone
          });
        } else {	        
          marker1 = new window.google.maps.Marker({
              position: latlng,                                          
              map: this.map,	                   
              icon: icone,
              visible: vVisible,
              title: numero
          });
        }
        
        window.google.maps.event.addListener(marker1, 'click', function() {
          _self.abrirInfowindow(marker1, dadosDoVeiculo, itemPercurso.condutor, tempoParadoOuVelocidade, itemPercurso.ignicao, itemPercurso.dataHoraGPS2, itemPercurso.indice, itemPercurso.descricaoPoI);
         
           if (marker1.getAnimation() != null) {
               marker1.setAnimation(null);
           }       
           
           if (!itemPercurso.descricaoPoI) {
              _self.recuperarEndereco(itemPercurso.latitude, itemPercurso.longitude);
           }
            
        });       
      } else {
         if (isExibirOrdem) {
             marker1 = new window.MarkerWithLabel({
                      position: latlng,
                      labelContent: numero,
                      labelAnchor: new window.google.maps.Point(24, 34),
                      labelClass: classeCss, 
                      labelStyle: {opacity: 1},
                      icon: { url: icone },
                      visible: vVisible
            });
        } else {
             marker1 = new window.google.maps.Marker({
                       position: latlng,   
                       icon: icone,
                       title: numero,
                       visible: vVisible
             });
        }
      }
      
      this.arrMarkerPercurso.push(marker1); 
      if (plotarNoMapa && indiceQuebraPorZoom > -1 && itemPercurso.indice > 1 && itemPercurso.indice < this.dadosPercursoSelecionado.lista.length) {
        this.quebraPorZoom[indiceQuebraPorZoom].push(marker1);
      }
    },
    desenharPolyline() {
        if (!this.perfilVelocidade) {
          return this.desenharPolylineSemCor();
        } else {
          return this.desenharPolylineColorida();
        }
    },
    desenharPolylineSemCor(){
        this.dadosPercursoSelecionado.coordenadas = null;
        this.dadosPercursoSelecionado.coordenadas = [];
 
        for (var j=0; j < this.dadosPercursoSelecionado.lista.length; j++ ) {         
            this.dadosPercursoSelecionado.coordenadas.push(this.$refs.gmc.getLatLng(this.dadosPercursoSelecionado.lista[j].latitude, this.dadosPercursoSelecionado.lista[j].longitude));
        }
        
        var iconsetngs = { 
          path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, 
          scale:2,fillColor: '#A9A9A9', strokeColor: '#A9A9A9', fillOpacity: 1   
        };
            
        var perimetroPath = new window.google.maps.Polyline({
          path: this.dadosPercursoSelecionado.coordenadas,
          geodesic: true,              
          strokeColor: this.dadosPercursoSelecionado.cor,          
          strokeOpacity: 1.0,
          strokeWeight: 3,
          icons: [{ icon: iconsetngs, offset: '10%', repeat: '100px'}] 
        });

        perimetroPath.setMap(this.map);	
        let arrSegmentos = [];
        arrSegmentos.push(perimetroPath);

        //console.log("Segmentos sem cor" + arrSegmentos);
        return arrSegmentos;        
    },
    desenharPolylineColorida() {
      this.dadosPercursoSelecionado.coordenadas = null;
      this.dadosPercursoSelecionado.coordenadas = [];
  
      
      // Coletar coordenadas
      for (let j = 0; j < this.dadosPercursoSelecionado.lista.length; j++) {
          this.dadosPercursoSelecionado.coordenadas.push(
              this.$refs.gmc.getLatLng(
                  this.dadosPercursoSelecionado.lista[j].latitude,
                  this.dadosPercursoSelecionado.lista[j].longitude
              )
          );
      }
  
      // Desenhar polylines de acordo com as faixas de velocidade
      let segmento = [];
      let corAtual = '';
      let arrSegmentos = [];
  
      for (let j = 0; j < this.dadosPercursoSelecionado.lista.length - 1; j++) {
          const pontoAtual = this.dadosPercursoSelecionado.lista[j];
          const pontoProximo = this.dadosPercursoSelecionado.lista[j + 1];
          
          const coordAtual = this.$refs.gmc.getLatLng(pontoAtual.latitude, pontoAtual.longitude);
          const coordProxima = this.$refs.gmc.getLatLng(pontoProximo.latitude, pontoProximo.longitude);
  
          // Determinar a cor baseada na velocidade
          const velocidade = parseFloat(pontoAtual.velocidadeAtual);
          let corNova = '';
  
          
          if (velocidade >= parseFloat(this.perfilVelocidade.velocidadeFaixa1Inicio) && velocidade <= parseFloat(this.perfilVelocidade.velocidadeFaixa1Fim)) {          
              corNova = this.perfilVelocidade.corFaixa1;              
          } else if (velocidade >= parseFloat(this.perfilVelocidade.velocidadeFaixa2Inicio) && velocidade <= parseFloat(this.perfilVelocidade.velocidadeFaixa2Fim)) {          
            corNova = this.perfilVelocidade.corFaixa2;                            
          } else if (velocidade >= parseFloat(this.perfilVelocidade.velocidadeFaixa3Inicio) && velocidade <= parseFloat(this.perfilVelocidade.velocidadeFaixa3Fim)) {          
            corNova = this.perfilVelocidade.corFaixa3;              
          } else if (this.perfilVelocidade.velocidadeFaixa4Inicio && velocidade >= parseFloat(this.perfilVelocidade.velocidadeFaixa4Inicio) && velocidade <= parseFloat(this.perfilVelocidade.velocidadeFaixa4Fim)) {          
            corNova = this.perfilVelocidade.corFaixa4;                            
          } else {
            corNova = "#000000";
          }
            
          // Se a cor mudar, desenhe a polyline atual e comece um novo segmento
          if (corNova !== corAtual) {
              if (segmento.length > 0) {
                  arrSegmentos.push(this.desenharSegmento(segmento, corAtual));
              }
              segmento = [coordAtual];
              corAtual = corNova;
          }
  
          segmento.push(coordProxima);
      }
  
      // Desenhar o último segmento
      if (segmento.length > 0) {
          arrSegmentos.push(this.desenharSegmento(segmento, corAtual));
      }

      //console.log("Segmentos com cor" + arrSegmentos);

      return arrSegmentos;
    },  
    desenharSegmento(segmento, cor) {
        var iconsetngs = {
            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 1,
            fillColor: '#A9A9A9',
            strokeColor: '#A9A9A9',
            fillOpacity: 1
        };
    
        var perimetroPath = new window.google.maps.Polyline({
            path: segmento,
            geodesic: true,
            strokeColor: cor,
            strokeOpacity: 1.0,
            strokeWeight: 3,
            icons: [{ icon: iconsetngs, offset: '10%', repeat: '100px' }]
        });
    
        perimetroPath.setMap(this.map);
        return perimetroPath;
    },
    limparMarcadoresEPolylineTodosRastreamentos(){ 	  
      if (this.arrMarkerTodosPercursos.length > 0) {
        for(var i=0; i < this.arrMarkerTodosPercursos.length; i++) {
          
            this.arrMarkerTodosPercursos[i].setMap(null);
          
        }

        this.arrMarkerTodosPercursos = null;
        this.arrMarkerTodosPercursos = [];
        console.log("Polylines para apagar " + this.arrPolylines.length);
        for(var j=0; j < this.arrPolylines.length; j++) {
          try {            
            this.arrPolylines[j].setMap(null);
          } catch (e) { console.log("Aqui DDDD" + e); }
        }
        this.arrPolylines = null;
        this.arrPolylines = [];

        this.arrMarkerPercurso = null;
        this.arrMarkerPercurso = [];
      }
    },
    exibirOcultarMarcadores() {
      if (this.arrMarkerTodosPercursos.length > 0) {
        this.marcadoresExibidos = !this.marcadoresExibidos;
        for(var i=0; i < this.arrMarkerTodosPercursos.length; i++) {	
            this.arrMarkerTodosPercursos[i].setVisible(this.marcadoresExibidos);
        }
      }
    },
    ocultarMarcadores() {
      if (this.arrMarkerTodosPercursos.length > 0) {		
        for(var i=0; i < this.arrMarkerTodosPercursos.length; i++) {	
            this.arrMarkerTodosPercursos[i].setVisible(false);
        }
        this.marcadoresExibidos = false;
      }
    },
    exibirMarcadores() {
      if (this.arrMarkerTodosPercursos.length > 0) {		
        for(var i=0; i < this.arrMarkerTodosPercursos.length; i++) {	
            this.arrMarkerTodosPercursos[i].setVisible(true);
        }
        this.marcadoresExibidos = true;
      }
    },
    centralizarPercurso(){
        var bounds = new window.google.maps.LatLngBounds();
        for(var i = 0; i < this.dadosPercursoSelecionado.coordenadas.length; i++) {
          bounds = bounds.extend(this.dadosPercursoSelecionado.coordenadas[i]);
        }
      
        this.map.setCenter(bounds.getCenter());
        this.map.fitBounds(bounds);         
    },
    centralizarTodosPercursos(){
        var bounds = new window.google.maps.LatLngBounds();
        for(var i = 0; i < this.arrMarkerTodosPercursos.length; i++) {
          bounds = bounds.extend(this.arrMarkerTodosPercursos[i].position);
        }
      
        this.map.setCenter(bounds.getCenter());
        this.map.fitBounds(bounds); 
    },
    abrirInfowindow(marcador, dadosVeiculo, condutorVeiculo, tempoParadaOuVelocidade, ignicao, dataAtualizacao, numero, endereco) {
        if (!endereco) {
          endereco = "Pesquisando ...";
        }

        var contentString = '<div id="content" style="width:300px">'+
                    '<div id="siteNotice">'+numero+'</div>'+
                    '<p style="color: #000000; font-weight: bold" id="firstHeading" class="firstHeading">'+ dadosVeiculo + '</p>'+
                    '<div id="bodyContent">'+
                    '<div class="section 1">'+'<p>'+ condutorVeiculo +'</p>'+'</div>'+
                    '<div class="section 2">'+'<p>'+ tempoParadaOuVelocidade +'</p>'
                    +'<p class="right">Igni&ccedil;&atilde;o: <span class="glyphicon glyphicon-cog '+ ignicao +'"></span></p>'+'</div>'+
                    '<div class="section adr" id="divEndereco"><p>'+ endereco + '</p></div>'+
                    '<div class="section 4"><a href="javascript:'+ this.getClickExibirStreetView(marcador) + '" class="btn">'+'Street View'+'</a>'+'<a href="javascript:click_AbrirPopUpCriarPoI('+ marcador.getPosition().lat() + "," + marcador.getPosition().lng() + ')" class="btn right">PT Interesse</a>'+'</div>'
                    +'<p class="lblDataAtualizacao"> <a href="javascript:' + this.getClickAbrirGoogleMaps(marcador) + '" id="divDataAtualizacao"> Atualizado em '+ dataAtualizacao +'</a></p>'+'</div>'+'</div>';
        if (this.infowindow == null) {
          this.infowindow = new window.google.maps.InfoWindow({				
            pixelOffset: new window.google.maps.Size(0, -12),
          });                
        }
      
        this.infowindow.close();
        this.infowindow.setContent(contentString);			    
        this.infowindow.open(this.map,marcador);            
        this.markerInfowindow = marcador;
    },
    getClickAbrirGoogleMaps(marcador) {
      return "window.open('https://www.google.com/maps/search/?api=1&query="+ marcador.getPosition().lat() + "," + marcador.getPosition().lng() + "', '_blank')";
    },
    getClickExibirStreetView(marcador){
      return "window.open('https://www.google.com/maps/@?api=1&map_action=pano&heading=-45&viewpoint="+ marcador.getPosition().lat() + "," + marcador.getPosition().lng() + "','_blank')";
    }, 
    exibirPontoRastreamentoSelecionado(event) {    
      if (event && event.node && event.node.data) {
        this.passoSelecionadoPercurso = event.node.data;        
      } 

      var latlng = this.$refs.gmc.getLatLng(this.passoSelecionadoPercurso.latitude, this.passoSelecionadoPercurso.longitude);
      
      for(var i = 0; i < this.arrMarkerTodosPercursos.length; i++) {
        if ( this.arrMarkerTodosPercursos[i].position.toString() === latlng.toString()) {
            this.arrMarkerTodosPercursos[i].setAnimation(window.google.maps.Animation.BOUNCE);
            window.google.maps.event.trigger(this.arrMarkerTodosPercursos[i], 'click');
        } else {
            this.arrMarkerTodosPercursos[i].setAnimation(null);
        }
      }
   
      this.map.setCenter(latlng);
      this.map.setZoom(20);				        
    },
    selecionarPontoInicialRastreamento(){
      this.passoSelecionadoPercurso = this.dadosPercursoSelecionado.lista[0];
      const rowNode = this.gridApiDetalhe.getDisplayedRowAtIndex(0);
      if (rowNode) {
        this.gridApiDetalhe.ensureIndexVisible(0);
        rowNode.setSelected(true);
      }

      this.exibirPontoRastreamentoSelecionado();
    },
    selecionarPontoFinalRastreamento(){
      this.passoSelecionadoPercurso = this.dadosPercursoSelecionado.lista[this.dadosPercursoSelecionado.lista.length - 1];

      const rowNode = this.gridApiDetalhe.getDisplayedRowAtIndex(this.dadosPercursoSelecionado.lista.length - 1);
      if (rowNode) {
        this.gridApiDetalhe.ensureIndexVisible(this.dadosPercursoSelecionado.lista.length - 1);
        rowNode.setSelected(true);
      }

      this.exibirPontoRastreamentoSelecionado();
    },
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        this.configExportExcel.headerTitle[0] = this.dadosPercursoSelecionado.resumo.placaVeiculo;
        const list = this.listaDetalhePercursoSelecionadoFiltrada; //this.dadosPercursoSelecionado.lista;
        const data = this.formatJson(this.configExportExcel.headerVal, list)
        excel.export_json_to_excel({
          header: this.configExportExcel.headerTitle,
          data,
          filename: this.configExportExcel.fileName,
          autoWidth: this.configExportExcel.cellAutoWidth,
          bookType: this.configExportExcel.selectedFormat
        })        
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    executarAnimacao() {  
      if (this.velocidadeAnimacao === 0) {
        this.velocidadeAnimacao = 1;
        this.ocultarMarcadores();      
        this.animarProximoPasso()
      } else {
        this.velocidadeAnimacao = 0;
        this.exibirMarcadores(); 
        this.marcadorPlay.setMap(null);
        this.marcadorPlay = null;
      }

    },
    animarProximoPasso() {
      if (this.velocidadeAnimacao > 0) {
        let _self = this;
        if (this.passoAnimacao < _self.dadosPercursoSelecionado.coordenadas.length - 1) {
          setTimeout(function() { _self.exibirMarcadorPlay(_self.dadosPercursoSelecionado.coordenadas[_self.passoAnimacao]) } , _self.getVelocidadeAnimacao());
          
          const rowNode = this.gridApiDetalhe.getDisplayedRowAtIndex(_self.passoAnimacao);
          if (rowNode) {
            this.gridApiDetalhe.ensureIndexVisible(_self.passoAnimacao);
            rowNode.setSelected(true);
          }

          this.passoAnimacao = this.passoAnimacao + 1;
        } else {
          this.velocidadeAnimacao = 0;
          this.passoAnimacao = 0;
          this.exibirMarcadores();
        }
      }
    },  
    exibirMarcadorPlay(coordenadas) {  
      if (this.velocidadeAnimacao > 0) { 
        this.passoSelecionadoPercurso = this.dadosPercursoSelecionado.lista[this.passoAnimacao];
        if (this.marcadorPlay === null) {
            this.marcadorPlay = new window.google.maps.Marker({
              position: coordenadas,
              map: this.map,
              icon: { url: this.publicPath + 'imagens/markerIconCar.png' }
            });
        } else {
            this.marcadorPlay.setPosition(coordenadas);
        }
        this.map.setCenter(coordenadas);        
        this.animarProximoPasso();
      }
    },
    getVelocidadeAnimacao() {
        switch (this.velocidadeAnimacao) {
          case 1: return 1750;
          case 2: return 1500;
          case 3: return 1250;
          case 4: return 1000;
          case 5: return 500;
          case 6: return 333;
          case 7: return 250;
          case 8: return 200;
          case 9: return 167; 
          case 10: return 100;
        }
    },
    setVelocidadeAnimacao(incremento) {
      this.velocidadeAnimacao = this.velocidadeAnimacao + incremento;
    },    
    carregarProximoEndereco() {       
      if (!this.dadosPercursoSelecionado.lista || this.dadosPercursoSelecionado.lista.length == this.indiceAtualListaDetalhe){
        this.indiceAtualListaDetalhe = 0;
        return;
      }
      let linhaAtual =  this.dadosPercursoSelecionado.lista[this.indiceAtualListaDetalhe];

      if (linhaAtual.descricaoPoI) {
        //Se tiver endereço passa para o proximo.
        this.indiceAtualListaDetalhe = this.indiceAtualListaDetalhe + 1;
        setTimeout(this.carregarProximoEndereco(), 100);
        return;
      }
      let indexInner = this.indiceAtualListaDetalhe;

      let vQueryString = 'format=json&lat=' + linhaAtual.latitude + '&lon=' + linhaAtual.longitude + '&addressdetails=1&accept-language=pt';
      this.indiceAtualListaDetalhe = this.indiceAtualListaDetalhe + 1;

      axios.post('https://nominatim2.concept.inf.br/nominatim/reverse?' + vQueryString, null, {              
              responseEncoding: 'iso88591', withCredentials: false } )
      .then((response) => {
          let endereco = ""; 
          if (response.data) {   
              let resultado = response.data;                 
              if (resultado.address.road) { endereco = endereco + resultado.address.road; }
              if (resultado.address.city && ( resultado.address.city == 'Teresina' || resultado.address.city == 'Timon')) {
                  if (resultado.address.residential) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.residential; }
                  if (resultado.address.suburb) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.suburb; }
              }
              if (resultado.address.town) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.town; }                	
              if (resultado.address.village) { endereco = endereco   + ( endereco != '' ? "," : "") + resultado.address.village; }
              if (resultado.address.city) { endereco = endereco   + ( endereco != '' ? "," : "") + resultado.address.city; }
              if (resultado.address.state) { endereco = endereco  + ( endereco != '' ? "," : "") + resultado.address.state; }
              if (resultado.address.postcode) { endereco = endereco  + ( endereco != '' ? "," : "") + resultado.address.postcode; }

          } else {
              endereco = "Endereço não localizado.";
          }

          linhaAtual.descricaoPoI = endereco;
          
          const rowNode = this.gridApiDetalhe.getDisplayedRowAtIndex(indexInner);
          if (rowNode) {            
            rowNode.setDataValue("descricaoPoI", endereco);
          }
          
          let _self = this;
          setTimeout(_self.carregarProximoEndereco(), 300);
      })
      .catch(() => { 
          let _self = this;          
          linhaAtual.descricaoPoI = "Endereço não localizado;";
          setTimeout(_self.carregarProximoEndereco(), 300);
      })  
    },
    criarBotaoOcultarGrid() {            
        let self_ = this;

        var controlUI = this.criarBotaoGenerico(this.botaoOcultarGridDiv, 'Clique para exibir/ocultar Grid', null, 'imagens/iconesMapa/exibirocultar.png');

        window.google.maps.event.addDomListener(controlUI, 'click', function() {
            self_.exibirGrid  = !self_.exibirGrid;
            //self_.toggleFullscreen();
        });
    },
    criarBotaoImprimir() {            
        var controlUI = this.criarBotaoGenerico(this.botaoImprimirDiv, 'Clique para imprimir o mapa', null, 'imagens/iconesMapa/imprimir.png');
        let self_ = this;
        window.google.maps.event.addDomListener(controlUI, 'click', function() {
            //window.print();
            self_.print();
        });
    },
    criarBotaoLimparArea() {     
          
      var controlUI = this.criarBotaoGenerico(this.btnLimparAreaDiv, 'Clique para limpar a área', null, 'imagens/iconesMapa/limpararea.png');
      let self_ = this;
      window.google.maps.event.addDomListener(controlUI, 'click', function() {
          self_.measureReset();
      });

      this.quadroCalculoDiv = window.document.createElement('div');		  
      this.map.controls[window.google.maps.ControlPosition.LEFT_TOP].push(this.quadroCalculoDiv);

      var controlUI2 = window.document.createElement('div');
      controlUI2.style.backgroundColor = 'black';
      controlUI2.style.borderStyle = 'solid';
      controlUI2.style.borderWidth = '2px';
      controlUI2.style.cursor = 'pointer';
      controlUI2.style.textAlign = 'left';
      controlUI2.title = 'Quadro resumo do cálculo da área';
      this.quadroCalculoDiv.appendChild(controlUI2);

      // Set CSS for the control interior
      var controlText = window.document.createElement('div');
      controlText.style.fontFamily = 'Arial,sans-serif';
      controlText.style.fontSize = '12px';
      controlText.style.color = 'white';
      controlText.style.paddingLeft = '4px';
      controlText.style.paddingRight = '4px';
      controlText.innerHTML = ' <span id="spanLength" ref="spanLength">0</span> m <br> <span id="spanArea" ref="spanArea">0</span> m² <br> <span id="spanAreaHa2" ref="spanAreaHa2">0</span> ha';
      controlUI2.appendChild(controlText);
    },
    criarBotaoExibirOcultar() {            
      let self_ = this;

      var controlUI = this.criarBotaoGenerico(this.botaoVerTodosDiv, 'Clique para exibir/ocultar os marcadores', null, 'imagens/iconesMapa/exibirmarcadores.png');

      window.google.maps.event.addDomListener(controlUI, 'click', function() {
          self_.exibirOcultarMarcadores();
      });
    },
    criarBotaoExibirOcultarPoI() {            
      let self_ = this;

      var controlUI = this.criarBotaoGenerico(this.botaoExibirOcultarPoI, 'Clique para exibir/ocultar os pontos de interesse', null, 'imagens/iconesMapa/exibirOcultarPoI.png');

      window.google.maps.event.addDomListener(controlUI, 'click', function() {
          //self_.exibirOcultarMarcadoresPoI();
          self_.exibirOcultarPoligonosPoI();
      });
    },
    criarBotaoExibirOcultarAvisos() {            
      let self_ = this;

      var controlUI = this.criarBotaoGenerico(this.botaoExibirOcultarAvisos, 'Clique para exibir/ocultar os avisos', null, 'imagens/iconesMapa/exibirOcultarAviso.png');

      window.google.maps.event.addDomListener(controlUI, 'click', function() {          
          self_.exibirOcultarMarcadoresAvisos();          
      });
    },
    criarBotaoGenerico(btnDiv, btnTooltip, btnTitulo, btnIcone) {        
            
        if (btnDiv != null) {
            this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].removeAt(this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].getLength() - 1);
        }
        
        btnDiv = window.document.createElement('div');
        btnDiv.style.padding = '2px';
        btnDiv.style.width = '32px';
            
        // Set CSS for the control border
        var controlUI = document.createElement('div');
        controlUI.style.backgroundColor = '#fff';
        controlUI.style.border = '2px solid #fff';            
        controlUI.style.borderRadius = '3px';
        controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        controlUI.style.cursor = 'pointer';
        controlUI.style.marginBottom = '5px';
        controlUI.style.textAlign = 'center';        
        if (btnIcone) {        
            controlUI.style.backgroundImage = "url(" + btnIcone + ")";
            controlUI.style.height = '25px';
            controlUI.style.width = '25px';
            controlUI.style.top = '11px';
            controlUI.style.left = '120px';
        }
        controlUI.title = btnTooltip;
        btnDiv.appendChild(controlUI);

        // Set CSS for the control interior
        if (btnTitulo) {
          var controlText = window.document.createElement('div');
          controlText.style.color = '#000000';
          controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
          controlText.style.fontSize = '12px';
          controlText.style.lineHeight = '24px';
          controlText.style.paddingLeft = '5px';
          controlText.style.paddingRight = '5px';		  
          controlText.innerHTML = btnTitulo;
          controlUI.appendChild(controlText);
        }
                        
        btnDiv.index = 1;
        this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].push(btnDiv);

        return controlUI;
    },
    print() {
        //const el = this.$refs.divMap;
        const el = document.querySelector('#map > div:first-of-type');

        const options = {
            type: 'dataURL',
            useCORS: true,
            optimized: false,
            allowTaint: false,
            async:false,
            ignoreElements: (node) => {
                return node.nodeName === 'IFRAME';
            }                
        }
        this.$html2canvas(el, options).then(canvas => {
            const url = canvas;
            var fileLink = document.createElement('a');
            fileLink.href = url;
            fileLink.setAttribute('download', 'percurso.png');
            document.body.appendChild(fileLink);
            fileLink.click();
            window.URL.revokeObjectURL(url);
            fileLink.remove();
          });
    },
    measureAdd(latLng) {
        var marker = new window.google.maps.Marker({
            map: this.map,
            position: latLng,
            draggable: true,
            raiseOnDrag: false,
            title: "Arraste-me",
            icon: new window.google.maps.MarkerImage("/images/demos/markers/measure-vertex.png", new window.google.maps.Size(9, 9), new window.google.maps.Point(0, 0), new window.google.maps.Point(5, 5))
        });

        this.measure.mvcLine.push(latLng);
        this.measure.mvcPolygon.push(latLng);

        this.measure.mvcMarkers.push(marker);

        var latLngIndex = this.measure.mvcLine.getLength() - 1;

        window.google.maps.event.addListener(marker, "mouseover", function() {
            marker.setIcon(new window.google.maps.MarkerImage("/images/demos/markers/measure-vertex-hover.png", new window.google.maps.Size(15, 15), new window.google.maps.Point(0, 0), new window.google.maps.Point(8, 8)));
        });

        window.google.maps.event.addListener(marker, "mouseout", function() {
            marker.setIcon(new window.google.maps.MarkerImage("/images/demos/markers/measure-vertex.png", new window.google.maps.Size(9, 9), new window.google.maps.Point(0, 0), new window.google.maps.Point(5, 5)));
        });

        window.google.maps.event.addListener(marker, "drag", function(evt) {
            this.measure.mvcLine.setAt(latLngIndex, evt.latLng);
            this.measure.mvcPolygon.setAt(latLngIndex, evt.latLng);
        });

        window.google.maps.event.addListener(marker, "dragend", function() {
            if (this.measure.mvcLine.getLength() > 1) {
                this.measureCalc();
            }
        });

        if (this.measure.mvcLine.getLength() > 1) {
            if (!this.measure.line) {
                this.measure.line = new window.google.maps.Polyline({
                    map: this.map,
                    clickable: false,
                    strokeColor: "#FF0000",
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    path:this.measure. mvcLine
                });
            }

            if (this.measure.mvcPolygon.getLength() > 2) {

                if (!this.measure.polygon) {

                    this.measure.polygon = new window.google.maps.Polygon({
                        clickable: false,
                        map: this.map,
                        fillOpacity: 0.25,
                        strokeOpacity: 0,
                        paths: this.measure.mvcPolygon
                    });
                }
            }
        }

        if (this.measure.mvcLine.getLength() > 1) {
            this.measureCalc();
        }
    },
    measureCalc() {

        var length = window.google.maps.geometry.spherical.computeLength(this.measure.line.getPath());
        window.document.getElementById('spanLength').innerText = length.toFixed(1);
        

        if (this.measure.mvcPolygon.getLength() > 2) {
            var area = window.google.maps.geometry.spherical.computeArea(this.measure.polygon.getPath());
            window.document.getElementById('spanArea').innerText = area.toFixed(1);
            window.document.getElementById('spanAreaHa2').innerText = (area.toFixed(1)*0.0001).toPrecision(2);
        }

    },
    measureReset() {
        if (this.measure.polygon) {
            this.measure.polygon.setMap(null);
            this.measure.polygon = null;
        }
        if (this.measure.line) {
            this.measure.line.setMap(null);
            this.measure.line = null
        }

        this.measure.mvcLine.clear();
        this.measure.mvcPolygon.clear();

        this.measure.mvcMarkers.forEach(function(elem) {
            elem.setMap(null);
        });
        this.measure.mvcMarkers.clear();
        window.document.getElementById('spanLength').innerText = "0";
        window.document.getElementById('spanArea').innerText = "0";
        window.document.getElementById('spanAreaHa2').innerText = "0";
    },
    recuperarEndereco(latitude, longitude) {
      let vQueryString = 'format=json&lat=' + latitude + '&lon=' + longitude + '&addressdetails=1&accept-language=pt';

      axios.post('https://nominatim2.concept.inf.br/nominatim/reverse?' + vQueryString, null, {              
              responseEncoding: 'iso88591', withCredentials: false } )
      .then((response) => {
          let endereco = ""; 
          if (response.data) {   
              let resultado = response.data;                 
              if (resultado.address.road) { endereco = endereco + resultado.address.road; }
              if (resultado.address.city && ( resultado.address.city == 'Teresina' || resultado.address.city == 'Timon')) {
                  if (resultado.address.residential) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.residential; }
                  if (resultado.address.suburb) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.suburb; }
              }
              if (resultado.address.town) { endereco = endereco + ( endereco != '' ? "," : "") + resultado.address.town; }                	
              if (resultado.address.village) { endereco = endereco   + ( endereco != '' ? "," : "") + resultado.address.village; }
              if (resultado.address.city) { endereco = endereco   + ( endereco != '' ? "," : "") + resultado.address.city; }
              if (resultado.address.state) { endereco = endereco  + ( endereco != '' ? "," : "") + resultado.address.state; }
              if (resultado.address.postcode) { endereco = endereco  + ( endereco != '' ? "," : "") + resultado.address.postcode; }

          } else {
              endereco = "Endereço não localizado.";
          }

          document.getElementById("divEndereco").innerHTML = "<p>" + endereco + "</p>";           
      })
      .catch((error) => {           
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - carregarProximoEndereco - " + error); 
          document.getElementById("divEndereco").innerHTML = "<p>Endereço não localizado</p>";      
      })  
    },
    createCircleGeometry(center, radius) {
      var circlePoints = [];
      var steps = 360;
      var stepSize = 360 / steps;
      for (var i = 0; i < steps; i++) {
        var angle = i * stepSize;
        var lat = center.lat + (radius / 111300) * Math.cos(angle * Math.PI / 180);
        var lng = center.lng + (radius / (111300 * Math.cos(center.lat * Math.PI / 180))) * Math.sin(angle * Math.PI / 180);
        circlePoints.push({lat: lat, lng: lng});
      }
      return circlePoints;
    },
    fetchListaPoI() {
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('statusAtivo', 'true');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('pageNum', 0);
        params.append('pageSize', 500000);

        axios.post("/PontoInteresseRestServlet", params, {
            credentials: 'include',
            responseEncoding: 'iso88591',
            withCredentials: true
        })
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99") {
                    // Efetuar logoff
                    this.$router.push({ path: '/login' });
                } else {
                    let poligono = [];
                    let circulo = null;

                    this.listaPoI = response.data.lista;
                    this.listaPoI.forEach((poi) => {
                        // if (poi.selecionado) {
                        //     this.plotarPoiNoMapa(poi);
                        // }

                      if (poi.selecionado) {                        
                          if (poi.hasOwnProperty('poligonoPoIJSON')) {
                              var listaPontos = JSON.parse(poi.poligonoPoIJSON);                                    
                              poligono = []; 
                                  
                              for(var i=0; i < listaPontos.length - 1; i++) {                
                                  poligono.push(new window.google.maps.LatLng(parseFloat(listaPontos[i].lat), parseFloat(listaPontos[i].long)));
                              }
                              
                              this.map.data.add({ geometry: new window.google.maps.Data.Polygon([poligono]), id: poi.id, properties: {'codigo':poi.codigo, 'nome':poi.nome, 'descricao':poi.descricao, 'icone': poi.icone, 'corEmHexa': poi.corEmHexa } });                                    
                              
                          } else {            
                              circulo = this.createCircleGeometry({lat: parseFloat(poi.latitude), lng: parseFloat(poi.longitude)}, parseFloat(poi.raio)*1000 );                      
                              this.map.data.add({ geometry: new window.google.maps.Data.Polygon([circulo]), id: poi.id, properties: {'codigo':poi.codigo, 'nome':poi.nome, 'descricao':poi.descricao, 'icone': poi.icone, 'corEmHexa': poi.corEmHexa } });
                          }
                    
                      }
                    });

                    this.map.data.setStyle( function(feature) {   
                        var color = '#FF0000';
                        if (feature.getProperty('corEmHexa')) {
                            color = feature.getProperty('corEmHexa');
                        }
                        return /** @type {!google.maps.Data.StyleOptions} */({
                            strokeColor: '#FF0000',
                            strokeOpacity: 0.5,
                            strokeWeight: 2,
                            fillColor: color,
                            fillOpacity: 0.35
                        });
                    });

                    let _self = this;
                    this.map.data.addListener('click', function(event) {                            
                        var infowindow = new window.google.maps.InfoWindow();
                        let conteudo = "<div style='padding-bottom: 5px; overflow:hidden'> ";                        
                        conteudo = conteudo + "  <p> PONTO DE INTERESSE </p>";                            
                        conteudo = conteudo + "  <div> <img src='" + _self.publicPath + "imagens/iconsPontoInteresse/" + event.feature.getProperty('icone') + ".png" + "'/> </div>";
                        conteudo = conteudo + "</div>";
                        conteudo = conteudo + "<div style='padding-bottom: 5px;'> ";
                        conteudo = conteudo +"   <div style='margin-left: 45px'> CODIGO: <br/><strong style='white-space: pre-line'>" + event.feature.getProperty('codigo') + "</strong>  </div>";                        
                        conteudo = conteudo + "</div>";
                        conteudo = conteudo + "<div style='padding-bottom: 5px;'>NOME: <br/><strong style='white-space: pre-line'>" + event.feature.getProperty('nome') + "</strong> </div>"
                        conteudo = conteudo + "<div style='padding-bottom: 10px;'>DESCRIÇÃO: <br/><strong style='white-space: pre-line'>" + event.feature.getProperty('descricao') + "</strong> </div>"
                        infowindow.setContent(conteudo);
                        infowindow.setPosition(event.latLng);
                        infowindow.open(_self.map);
                    });
                }
            })
            .catch((error) => {
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error);
            })

    },
    plotarPoiNoMapa(poi) {
        let titulo = poi.nomeGrupo + " - " + poi.nome + (poi.hasOwnProperty("codigo") && poi.codigo !== "" ? " - " + poi.codigo : "");

        let location = this.$refs.gmc.getLatLng(poi.latitude, poi.longitude);
        let icone = this.publicPath + "imagens/iconsPontoInteresse/" + poi.icone + ".png";

        var marker = new window.google.maps.Marker({
            position: location,
            map: this.map,
            title: titulo,
            visible: true,
            icon: { url: icone }
        });

        this.markersPoI.set(marker.getTitle(), marker);

        window.google.maps.event.addListener(marker, 'click', function () {
            if (marker.getAnimation() != null) {
                marker.setAnimation(null);
            }
        });
    },
    exibirOcultarPoligonosPoI() {
      if (this.map.data) {
        if (this.map.data.getMap()) {
          this.map.data.setMap(null);
        } else {
          this.map.data.setMap(this.map);
        }
      }
    },
    exibirOcultarMarcadoresPoI() {
      if (this.markersPoI.size > 0) {
        this.marcadoresPoIExibidos = !this.marcadoresPoIExibidos;
        let self_ = this;
        this.markersPoI.forEach(function (mpoi) {
          mpoi.setVisible(self_.marcadoresPoIExibidos);
        });
      }
    },
    click_gravarPoIExibidos() {
        let idPoiSelecionados = [];

        this.gridApiPoi.forEachNode(function (node) {
            if (node.data.selecionado) {
                idPoiSelecionados.push(node.data.id);
            }
        });

        const params = new URLSearchParams();
        params.append('method', 'RegistrarMarcados');
        if (idPoiSelecionados.length > 0) {
            params.append('idPontosInteresses', idPoiSelecionados);
        }
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);

        axios.post('/PontoInteresseRestServlet', params, {
            credentials: 'include',
            responseEncoding: 'iso88591',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
            withCredentials: true
        }
        ).then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99") {
                // Efetuar logoff
                this.$router.push({ path: '/login' });
            } else {
                if (response.data.hasOwnProperty("error")) {
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Erro',
                        text: response.data.error,
                        acceptText: 'OK'
                    })
                } else {
                    this.$vs.dialog({
                        color: 'success',
                        title: `Sucesso`,
                        text: response.data.mensagem,
                        acceptText: 'OK'
                    })
                }
            }
        });
    },
    alterarVisbilidadeMarkers(lista, status) {
        //var bounds = this.map.getBounds();
        var vVisible = status;
        for(var i=0; i < lista.length; i++) {	        
          if (vVisible) {
              lista[i].setMap(this.map);            
          } else {
              lista[i].setMap(null);
          }
          lista[i].setVisible(vVisible);
        }
        if (status) {
            this.qtdMarkersExibidos = this.qtdMarkersExibidos + lista.length; 
        } else {
            this.qtdMarkersExibidos = this.qtdMarkersExibidos - lista.length;
        }
    },
    ajustarVisbilidadeoutrosMarkers(lista) {
        var bounds = this.map.getBounds();
        let vVisible = true;
        for(var i=0; i < lista.length; i++) {	
          vVisible = bounds.contains(lista[i].getPosition()) && lista[i].getVisible();
          if (vVisible) {
            lista[i].setMap(this.map);            
          } else {
            lista[i].setMap(null);
          }
        }
    },
    routePercursoNovaWindow(){
        let routeUrl = this.$router.resolve({
            name: "percursos",               
        });

        this.$store.commit('SET_DADOS_PARA_PERCURSO', { filtroVeiculoSelecionado: this.filtroVeiculoSelecionado, consolidadoPercursoSelecionado: this.consolidadoPercursoSelecionado, dadosPopUpParametroHora: this.dadosPopUpParametroHora});
        
        window.open(routeUrl.href, '_blank');
    },    
    toggleFullscreen(elem) {
        elem = document.getElementById('map') || document.documentElement;
      
        if (!document.fullscreenElement && !document.mozFullScreenElement &&
          !document.webkitFullscreenElement && !document.msFullscreenElement) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }
    },
    exportarParaKLM(){

      let dataInicioYYYYMMDDHHMMSS = null;
      let dataFimYYYYMMDDHHMMSS = null;

      if (this.consolidadoPercursoSelecionado.hasOwnProperty('dataFimYYYYMMDDHHMMSS')) {
        dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataInicioYYYYMMDDHHMMSS;
        dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataFimYYYYMMDDHHMMSS;
      } else {
        dataInicioYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraInicio + '00';
        dataFimYYYYMMDDHHMMSS = this.consolidadoPercursoSelecionado.dataYYYYMMDD + this.dadosPopUpParametroHora.filtroHoraFim + '59';
      }
      
      let idVeiculo = this.consolidadoPercursoSelecionado.idVeiculo;
      let codigoModulo = this.consolidadoPercursoSelecionado.codigoModulo;
      let marcaModulo = this.consolidadoPercursoSelecionado.marcaModulo;
      let exibirPercursoBkp = this.dadosPopUpParametroHora.exibirPercursoBkp;
      let somenteModuloParametro = true;
      let exportarParaKLM = true;
      this.fetchRastreamentoGenerico(dataInicioYYYYMMDDHHMMSS, dataFimYYYYMMDDHHMMSS, idVeiculo, codigoModulo, marcaModulo, this.chkExibirSohParadas, this.chkExibirMakerEmMovimento, exibirPercursoBkp, somenteModuloParametro, exportarParaKLM);        
    },
    fetchPerfilCoresVelocidade() {           
      const params = new URLSearchParams();      
      params.append('idCliente', this.$store.state.AppActiveUser.id);  
      params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);        
      params.append('pagina', -1);      

      axios.post("/rest/PerfilCoresVelocidadePercurso/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {                            
              if (response.data.Resultado.quantidade > 1) {
                  this.listaPerfisCores = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.listaPerfisCores = [];
                  this.listaPerfisCores.push(response.data.Resultado.lista.item);
              } else {
                  this.listaPerfisCores = [];
              }
          }
      })
      .catch((error) => {           
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchPerfilCoresVelocidade - " + error); 
      })    
                        
    },
    routeNovoPerfilCores() {
      this.exibirPopUpParametroHora = false;
      this.$router.push({ name: "configuracao-perfil-cores-edit"});
    },
    exibirOcultarMarcadoresAvisos() {      
      if (this.arrMarkerAvisos.length > 0) {
        this.marcadoresAvisosExibidos = !this.marcadoresAvisosExibidos;
        let self_ = this;
        this.arrMarkerAvisos.forEach(function (mpoi) {
          mpoi.setVisible(self_.marcadoresAvisosExibidos);
        });
      }
    },
    imprimirTabela() {
      // Cria um novo documento para impressão
      const printWindow = window.open('', '_blank');
      
      // Obtém o conteúdo HTML da tabela
      const tableElement = this.$refs.table2.$el;

      // Cria o conteúdo da página de impressão
      let printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Percursos Desenhados</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: center; }
            th { background-color: #f2f2f2; }
            .print-header { text-align: center; margin-bottom: 20px; }
            .hide-for-print { display: none; }
            .total-row { font-weight: bold; background-color: #f9f9f9; }
          </style>
        </head>
        <body>
          <h2 class="print-header">Percursos</h2>
          ${tableElement.outerHTML}
        </body>
        </html>
      `;
      
      // Escreve o conteúdo no novo documento
      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();
      
      // Espera que o conteúdo seja carregado antes de imprimir
      printWindow.onload = function() {
        printWindow.print();
        printWindow.onafterprint = function() {
          printWindow.close();
        };
      };
    },
     calcularTotalKm() {
      let total = 0;
      
      if (this.listaPercursosDesenhados && this.listaPercursosDesenhados.length > 0) {
        this.listaPercursosDesenhados.forEach(item => {
          if (item.resumo && item.resumo.distanciaPercorrida) {
            // Extrai apenas o número do formato "32,52 km"
            const valorStr = item.resumo.distanciaPercorrida.replace(/\s*km\s*$/i, '').trim();
            // Substitui vírgula por ponto para conversão numérica
            const valorNum = parseFloat(valorStr.replace(',', '.'));
            
            if (!isNaN(valorNum)) {
              total += valorNum;
            }
          }
        });
      }
      
      // Formata o resultado com 2 casas decimais e vírgula como separador
      return total.toFixed(2).replace('.', ',') + ' km';
    },
  },
  mounted() {    
    this.filtroDataInicio = String(new Date().fp_incr(-7).getTime() / 1000);
    this.filtroDataFim = String(new Date().getTime() / 1000);
    
    this.map = new window.google.maps.Map(document.getElementById('map'), {
        center: new window.google.maps.LatLng(-5, -42),       
        gestureHandling: 'greedy',
        zoom: 8,
        controlSize: 20,
        fullscreenControl:true,
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: {
            position: window.google.maps.ControlPosition.LEFT_TOP
        }
    }); 

    let self_ = this;
    window.google.maps.event.addListener(this.map, "click", function(evt) {
      self_.measureAdd(evt.latLng);
    });
    // window.google.maps.event.addListener(this.map, "dragstart", function() { 
    //   //self_.exibirOcultarMarcadores();
    // });
    // window.google.maps.event.addListener(this.map, "dragend", function() { 
    //   //self_.exibirOcultarMarcadores();
    // });

    this.nivelZoomAnterior = -1;
    
    window.google.maps.event.addListener(this.map, 'idle', function() {
      
      if (self_.map) {
          if (self_.nivelZoomAnterior > -1) {
                if (self_.nivelZoomAnterior > self_.map.getZoom()) {
                  
                  if (self_.map.getZoom() < self_.zoomStart ) {
                    
                    if (self_.quebraPorZoom[0].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[0], false);
                    } 
                    if (self_.quebraPorZoom[1].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[1], false);
                    } 
                    if (self_.quebraPorZoom[2].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[2], false);
                    } 
                    if (self_.quebraPorZoom[3].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[3], false);
                    } 
                    if (self_.quebraPorZoom[4].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[4], false);
                    }

                  } else if (self_.map.getZoom() < (self_.zoomStart + 1) ) {
                      
                    if (self_.quebraPorZoom[0].length > 0) {
                        self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[0], false);
                    }

                  } else if (self_.map.getZoom() < (self_.zoomStart + 3) && self_.marcadoresExibidos ) {
                    
                    if (self_.quebraPorZoom[1].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[1], false);
                    }

                  } else if (self_.map.getZoom() < (self_.zoomStart + 5) && self_.marcadoresExibidos ) {

                    if (self_.quebraPorZoom[2].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[2], false);
                    }

                  } else if (self_.map.getZoom() < (self_.zoomStart + 7) && self_.marcadoresExibidos ) {
                    
                    if (self_.quebraPorZoom[3].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[3], false);
                    }

                  } else if (self_.map.getZoom() < (self_.zoomStart + 9) && self_.marcadoresExibidos ) {
                    
                    if (self_.quebraPorZoom[4].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[4], false);
                    }

                  } 
                } else {

                  if (self_.map.getZoom() >= (self_.zoomStart + 8) && self_.marcadoresExibidos ) {
                    if (self_.quebraPorZoom[4].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[4], true);
                    }

                  } else if (self_.map.getZoom() >= (self_.zoomStart + 6) && self_.marcadoresExibidos ) {
                    if (self_.quebraPorZoom[3].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[3], true);
                    }

                  } else if (self_.map.getZoom() >= (self_.zoomStart + 4) && self_.marcadoresExibidos ) {
                    if (self_.quebraPorZoom[2].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[2], true);
                    }

                  } else if (self_.map.getZoom() >= (self_.zoomStart + 2) && self_.marcadoresExibidos ) {
                    if (self_.quebraPorZoom[1].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[1], true);
                    }

                  } else if (self_.map.getZoom() >= self_.zoomStart && self_.marcadoresExibidos ) {
                    if (self_.quebraPorZoom[0].length > 0) {
                      self_.alterarVisbilidadeMarkers(self_.quebraPorZoom[0], true);
                    }

                  } 

                }
            
                if (self_.quebraPorZoom[0].length > 0) {
                  self_.ajustarVisbilidadeoutrosMarkers(self_.quebraPorZoom[0]);
                } 
                if (self_.quebraPorZoom[1].length > 0) {
                  self_.ajustarVisbilidadeoutrosMarkers(self_.quebraPorZoom[1]);
                } 
                if (self_.quebraPorZoom[2].length > 0) {
                  self_.ajustarVisbilidadeoutrosMarkers(self_.quebraPorZoom[2]);
                } 
                if (self_.quebraPorZoom[3].length > 0) {
                  self_.ajustarVisbilidadeoutrosMarkers(self_.quebraPorZoom[3]);
                } 
                if (self_.quebraPorZoom[4].length > 0) {
                  self_.ajustarVisbilidadeoutrosMarkers(self_.quebraPorZoom[4]);
                }

                
          }
     
          self_.nivelZoomAnterior = self_.map.getZoom();
      }
      
      
    });

    this.criarBotaoExibirOcultar();
    this.criarBotaoOcultarGrid();
    this.criarBotaoImprimir();
    this.criarBotaoLimparArea();
    this.criarBotaoExibirOcultarPoI();
    this.criarBotaoExibirOcultarAvisos();
    this.fetchVeiculos(); 
    this.fetchListaPoI();
    this.fetchPerfilCoresVelocidade();
    
    if (this.pVeiculoSelecionado) {
      this.filtroVeiculoSelecionado = this.pVeiculoSelecionado;
      this.fetchListaConsolidado();
    }

    if (this.$store.getters.dadosParaPercurso.filtroVeiculoSelecionado) {
      this.filtroVeiculoSelecionado = this.$store.getters.dadosParaPercurso.filtroVeiculoSelecionado;
      if (this.$store.getters.dadosParaPercurso.consolidadoPercursoSelecionado) {
        this.consolidadoPercursoSelecionado = this.$store.getters.dadosParaPercurso.consolidadoPercursoSelecionado;
        this.dadosPopUpParametroHora = this.$store.getters.dadosParaPercurso.dadosPopUpParametroHora;
      }
      
      this.fetchListaConsolidado();      
    }
    
  },
  beforeDestroy() {
    this.map = null;
    this.markersPoI = null;
    this.arrMarkerTodosPercursos = null;
    this.arrPolylines = null;
    this.arrMarkerPercurso = null;
    this.arrMarkerAvisos = null;
    this.infowindow = null;
    this.markerInfowindow = null;
    this.botaoVerTodosDiv = null;
    this.botaoImprimirDiv = null;
    this.quadroCalculoDiv = null;
    this.btnLimparAreaDiv = null;
    this.marcadorPlay = null;
    this.mmgr = null;
},
  
}
